import { useQuery } from '@tanstack/react-query';
import { fetchInvoicingCandidates } from '../services/agreements';
import { agreementKeys } from './agreementKeys';

/** Gated on the selling dealer being known and the caller-supplied `enabled`
 *  (the Invoicing tab being active). */
export function useInvoicingCandidatesQuery(dealerId: string | undefined, productId: string | null, enabled: boolean) {
    return useQuery({
        queryKey: agreementKeys.invoicingCandidates(dealerId ?? '', productId),
        queryFn: () => fetchInvoicingCandidates(dealerId!, productId),
        enabled: !!dealerId && enabled,
    });
}
